import Axios from "./axios"  // 导入配置好的axios文件
import { Dialog ,Toast} from 'vant';

import { Base64 } from '../uploadImg/base64.js';
import Crypto from '../uploadImg/crypto.js';
import '../uploadImg/hmac.js';
import '../uploadImg/sha1.js';
import {Decrypt, Encrypt} from './Crypto.js';

// 封装axios请求函数，并用export导出

// get请求
export function get(apiUrl,datas) {
	var postData = '';
	// if(apiUrl=='/OAuth/SendCode'){
	// 	postData = {data: Encrypt(JSON.stringify(datas))};
	// }else if(apiUrl=='/Member/QuerayVIPH5/0'){
	// 	postData = {};
	// }else{
	// 	postData = {data: Encrypt(JSON.stringify(datas))};
	// }
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "get",
			url: apiUrl,
			headers: {
				'Content-Type': 'application/json;' 
			},
			params:datas,
			}).then(res=>{
				// let resData = null
				// if(res.data.data){
				// 	resData = Decrypt(res.data.data)
				// 	if(resData.indexOf('<form')!=-1){
							
				// 	}else if((resData.indexOf('{')!=-1&&resData.indexOf('}')!=-1)||(resData.indexOf('[')!=-1&&resData.indexOf(']')!=-1)){
				// 		resData = JSON.parse(resData)
				// 	}else if(resData == 'False'){
				// 		resData = false;
				// 	}else if(resData == 'True'){
				// 		resData = true;
				// 	}
				// }
				
				// res.data.data = resData;
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// put请求
export function put(apiUrl,datas) {
    
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "put",
			url: apiUrl,
			
			data:datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// delete请求
export function deleteP(apiUrl,datas) {
    
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "delete",
			url: apiUrl,
			data:datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}

// 拼接
export function getJ(apiUrl,datas) {
    return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "get",
			url: apiUrl+datas,
			headers: {
				'Content-Type': 'application/json;' 
			},
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// 请求头'Content-Type': 'application/json'
export function postP(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "post",
			url: apiUrl,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8' 
			},
			data:datas,
			transformRequest: [function () {
				// 对 data 进行任意转换处理
				return JSON.stringify(datas);
			  }],
			}).then(res=>{
				// let resData='';
				// if(res.data.data){
				// 	resData = Decrypt(res.data.data)
				// 	if(resData.indexOf('<form')!=-1){
						
				// 	}else if((resData.indexOf('{')!=-1&&resData.indexOf('}')!=-1)||(resData.indexOf('[')!=-1&&resData.indexOf(']')!=-1)){
				// 		resData = JSON.parse(resData)
				// 	}else if(resData == 'False'){
				// 		resData = false;
				// 	}else if(resData == 'True'){
				// 		resData = true;
				// 	}
				// }
				// res.data.data = resData
				
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
export function postX(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "post",
			url: apiUrl,
			
			data:datas,
			transformRequest: [function () {
				// 对 data 进行任意转换处理
				return JSON.stringify(datas);
			}],
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}



//上传
export function upload(apiUrl,file,params) {
	const param = new FormData() // 创建form对象
	param.append('file', file);
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	return new Promise((resolve,reject) => {
		return Axios.Axios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
	
}

export function deletePost(apiUrl,datas) {
    
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "delete",
			url: apiUrl,
			data:datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}




// 返回时间日期
function formatDate(value,boolean) {
	let date = new Date(value);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	if(boolean){
		return y + '' + MM + '' + d
	}else{
	  return y + '' + MM + '' + d + '' + h + '' + m + '' + s;
	}
  }
  // 生成随机数
  function random_string(len) {
	  len = len || 32;
	  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	  var maxPos = chars.length;
	  var pwd = '';
	  for (let i = 0; i < len; i++) {
		  pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	  }
	  return pwd;
  }
//上传http://39.108.79.18:8001/api/File/UploadFile
export function uploadOther(apiUrl,file,params) {
	let imgLists = [];
	
	var uploadFileSize = 1024 * 1024 * 100; // 上传文件的大小限制100m
	var policyText = {
		"expiration": "2022-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
		"conditions": [
			["content-length-range", 0, uploadFileSize] // 设置上传文件的大小限制 
		]
	};
	var accessid = 'LTAI0bbg7dKrg1uD';
	var accesskey = 'zG0zsvE5P8VxZ0ZlYJRYqiPiCCsXgn';
	var osshost = 'http://txggpic.oss-cn-shenzhen.aliyuncs.com';
	var policyBase64 = Base64.encode(JSON.stringify(policyText));
	var message = policyBase64;
	var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
		asBytes: true
	});
	var signature = Crypto.util.bytesToBase64(bytes);
	var timetamp = new Date().getTime();


	let stroeAs = formatDate(timetamp,true) +'/' + formatDate(timetamp,false) + random_string(5) + '.jpg' ;

	const param = new FormData() // 创建form对象
	param.append('key', stroeAs);
	param.append('policy', policyBase64);
	param.append('OSSAccessKeyId', accessid);
	param.append('success_action_status', '200');
	param.append('signature', signature);
	param.append('reportno', '');
	param.append('file', file);
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	
	// const oldAxios = Axios.Axios;
	return new Promise((resolve,reject) => { 
		return Axios.OtherAxios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
			
			resolve(osshost + '/' + stroeAs);
		}).catch(err=>{
			reject(err);
		})
	})
	
}







